import React, { useCallback, useEffect, useMemo, useState } from "react";

import { Link } from "react-router-dom";

import {
    Activate_UserClient_PUT,
    All_UserClient_List_POST,
    AssignRoles_UserClient_PUT,
    Assigned_RolesList_UserClient_POST,
    CurrencyList_LocalCountry_GET,
    DeActivate_UserClient_PUT,
    Delete_UserClient_DELETE,
    Deleted_UserClient_List_POST,
    Revive_UserClient_PUT,
} from "api/ApiConst";
import { handleActive, handleDelete, handleInactive, handleRevive } from "utils/UserUtils";
import dateUtilities from "utils/DateUtilities";

import AssignRoles from "components/common/AssignRoles";
import CheckboxButton from "components/common/CheckboxButton";
import CustomButton from "components/common/CustomButton";
import PageHeading from "components/common/PageHeading";
import PaginationDataTable from "components/common/PaginationDataTable";
import UserClientAddEdit from "./UserClientAddEdit";
import { API_SUCCESS } from "api/ResponseCodes";
import { SECTION_LOADER } from "utils/constants";
import { callGetApi, callPostApi } from "api/ApiCaller";
import toast from "react-hot-toast";

const UserClientMaster = () => {
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [viewDeletedList, setViewDeletedList] = useState(false);
    const [recordID, setRecordID] = useState(null);
    const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);
    const [showAssignRoleModal, setShowAssignRoleModal] = useState(false);
    const [currencyOptionsList, setCurrencyOptionsList] = useState([])

    useEffect(() => {
        if (!showAddUpdateModal) {
            setRecordID(null);
        }
    }, [showAddUpdateModal]);

    useEffect(() => {
        getCurrencyKeyValuePairList();
    }, [])
    
    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);

    const getCurrencyKeyValuePairList = () => {
        callGetApi(SECTION_LOADER, CurrencyList_LocalCountry_GET, {}, (response) => {
            if (response.errorCode === API_SUCCESS) {
                const options = response.responsePacket.map((currency) => ({
                    value: currency.currencyId,
                    label: currency.currencyTitle,
                    ...currency
                }));
                setCurrencyOptionsList(options);
            } else {
                toast.error(response.message);
            }
        });
    };
    const columns = useMemo(
        () => [
            {
                id: "status",
                name: "",
                selector: (row) => <div className={row.active ? "led-green" : "led-red"} title={row.active ? "Active" : "Inactive"} />,
                width: "60px",
                sortable: false,
            },
            {
                id: "name",
                name: "Name",
                selector: (row) => <Link to={"details?rId=" + row.uuid}>{row.firstName + " " + row.lastName}</Link>,
                sortable: false,
                wrap: 2,
            },
            {
                id: "userName",
                name: "User Name",
                selector: (row) => row.username,
                sortable: false,
            },
            {
                id: "mobile",
                name: "Mobile No.",
                selector: (row) => row.isdCode + " " + row.mobile,
                sortable: false,
            },
            {
                id: "email",
                name: "Email",
                selector: (row) => row.email,
                sortable: false,
                wrap: 2,
            },
            {
                id: "dateOfBirthTimeStamp",
                name: "DOB",
                selector: (row) => dateUtilities.formattedDate(row.dateOfBirthTimeStamp, "dd-MM-yyyy"),
                sortable: false,
            },
            {
                id: "createdAt",
                name: "Created Time",
                selector: (row) => dateUtilities.formattedDate(row.createdAt, "dd-MM-yyyy, hh:mm aa"),
                sortable: false,
            },
            {
                id: "action",
                name: "",
                selector: (row) => <div className="custom-column-action">{getActionButtons(row)}</div>,
                width: "80px",
                sortable: false,
            },
        ],
        [handleRefresh]
    );

    const getActionButtons = (row) => {
        return (
            <div className="d-flex align-items-center justify-content-between">
                {!row.deleted && (
                    <button className="listBtn me-2" onClick={() => handleEdit(row)}>
                        <i className="bx bx-pencil"></i>
                    </button>
                )}
                <div className="dropdown">
                    <button className="btn btn-primary btn-flat btn-addon btn-xs dropdown-toggle" title="More" data-bs-toggle="dropdown" aria-expanded="false" style={{ padding: "5px 10px 8px 10px" }}>
                        <i className="bx bx-chevron-down"></i>
                    </button>
                    <ul className="dropdown-menu dropdown-menu-right">
                        <>
                            {row.deleted ? (
                                <li onClick={() => handleReviveData(row)}>
                                    <i className="bx bx-log-out-circle"></i> Revive
                                </li>
                            ) : (
                                <>
                                    <li onClick={() => handleDeleteData(row)}>
                                        <i className="bx bx-trash"></i> Delete
                                    </li>
                                    <li onClick={() => handleActiveInactive(row)}>
                                        {row.active ? (
                                            <>
                                                <i className="bx bx-x-circle"></i> Inactive
                                            </>
                                        ) : (
                                            <>
                                                <i className="bx bx-check-circle"></i> Active
                                            </>
                                        )}
                                    </li>
                                    <li onClick={() => handleAssignRole(row)}>
                                        <i className="bx bxs-user-plus"></i> Assign Role
                                    </li>
                                </>
                            )}
                        </>
                    </ul>
                </div>
            </div>
        );
    };

    const handleEdit = (row) => {
        setRecordID(row.uuid);
        setShowAddUpdateModal(true);
    };

    const handleActiveInactive = (row) => {
        if (row.active) {
            handleInactive(DeActivate_UserClient_PUT.replaceAll("{recordID}", row.uuid), handleRefresh);
        } else {
            handleActive(Activate_UserClient_PUT.replaceAll("{recordID}", row.uuid), handleRefresh);
        }
    };
    //Delete Record
    const handleDeleteData = (row) => {
        handleDelete(Delete_UserClient_DELETE.replaceAll("{recordID}", row.uuid), handleRefresh);
    };

    //Revive Record
    const handleReviveData = (row) => {
        handleRevive(Revive_UserClient_PUT.replaceAll("{recordID}", row.uuid), handleRefresh);
    };

    //Assign Roles
    const handleAssignRole = (row) => {
        setRecordID(row.uuid);
        setShowAssignRoleModal(true);
    };

    const handleToggleDeletedView = () => setViewDeletedList(!viewDeletedList);

    return (
        <>
            {PageHeading("User Client List", "Dashboard", "/")}
            <div className="card">
                <CustomButton handleClick={() => setShowAddUpdateModal(true)} title="Create New" iconClass="bx bx-plus" buttonClass="createButton" />
                <div className="card-body tableView">
                    <PaginationDataTable
                        paginationUrl={viewDeletedList ? Deleted_UserClient_List_POST : All_UserClient_List_POST}
                        serverSidePagination={true}
                        search={true}
                        pagination={false}
                        columns={columns}
                    />
                    <CheckboxButton title="Deleted List" handleClick={handleToggleDeletedView} additionalClass="deletedBtn ml-auto" />
                </div>
            </div>
            {showAddUpdateModal && <UserClientAddEdit show={showAddUpdateModal}
                currencyOptionsList={currencyOptionsList}

                hideModal={() => setShowAddUpdateModal(false)} recordID={recordID} handleRefresh={handleRefresh} />}
            {showAssignRoleModal && (
                <AssignRoles
                    show={showAssignRoleModal}
                    hideModal={() => setShowAssignRoleModal(false)}
                    recordID={recordID}
                    handleRefresh={handleRefresh}
                    assignRole={AssignRoles_UserClient_PUT}
                    getAssignedRole={Assigned_RolesList_UserClient_POST}
                />
            )}
        </>
    );
};

export default UserClientMaster;
